<template>
  <v-card flat>
    <v-data-table
      :items="screenings | EventType(eventType)"
      class="elevation-1"
      hide-actions
      hide-headers
    >
      <template v-slot:items="props">
        <tr
          v-if="props.item"
        >
          <td class="pa-3 cursor-pointer" width="5%"
          @click.stop="goToScreenerOverview(props.item)">
            <div class="subheading">{{ props.index + 1 }}</div>
          </td>
          <td class="pa-3 cursor-pointer" width="10%" @click.stop="goToScreenerOverview(props.item)">
            <v-card>
              <v-layout row>
                <v-flex xs12>
                  <!-- Show thumbnail of screener -->
                  <template v-if="props.item.thumbnail_url">
                    <v-img
                      slot="activator"
                      :src="props.item.thumbnail_url"
                      contain
                    ></v-img>
                  </template>
                  <!-- Show thumbnail of first film if thumbnail is not available on screener -->
                  <template
                    v-else-if="
                      props.item.films &&
                        props.item.films[0] &&
                        props.item.films[0].thumburls
                    "
                  >
                    <v-img
                      slot="activator"
                      :src="props.item.films[0].thumburls"
                      contain
                    ></v-img>
                  </template>
                  <template v-else>{{ props.item.title[currentLocale] }}</template>
                </v-flex>
              </v-layout>
            </v-card>
          </td>
          <td class="pa-3 cursor-pointer" @click.stop="goToScreenerOverview(props.item)">
            <div>
              <h2 class="font-weight-regular">{{ props.item.title[currentLocale] }}</h2>
              <div class="subheading" v-if="props.item.is_vod_event">
                <span v-if="props.item.pivot.event_starts_at && isVodEventActive(props.item.id)">
                  {{ $t("vod.event.expire.in") }}&nbsp;:&nbsp;
                  <span
                    >{{
                      moment
                        .utc(vodEventEndTime(props.item.id))
                        .local()
                        .toNow(true)
                    }}
                  </span>
                </span>
                <v-chip
                  v-if="isVodEventExpired(props.item.id)"
                  small
                  color="error"
                  text-color="white"
                  >{{ $t("vod_event.expired") }}</v-chip
                >
                <v-chip
                  v-else-if="isVodEventActive(props.item.id)"
                  small
                  color="success"
                  text-color="white"
                  >{{ $t("vod_event.active") }}</v-chip
                >
              </div>
              <div v-else class="subheading" >
                {{
                  moment
                    .utc(props.item.screening_starts_at)
                    .local()
                    .format("lll")
                }}
              </div>
            </div>
          </td>
          <td class="pa-3 cursor-pointer" @click.stop="goToScreenerOverview(props.item)">
            <div>
              <template v-if="props.item.receipt_urls && props.item.receipt_urls.length">
                <v-tooltip slot="append" top color="primary">
                  <template v-for="(receipt, key) in props.item.receipt_urls">
                     <v-chip
                      :key="key"
                      slot="activator"
                      outline
                      color="secondary"
                      class="cursor-pointer white--text"
                      small
                      v-if="receipt.receipt_url"
                      @click.stop="viewReceipt(receipt.receipt_url)"
                    >
                    <strong
                      >{{ $t("screener.purchased.title") }} :
                      {{ receipt.plan }}</strong
                    >
                    <v-icon>mdi-download</v-icon>
                  </v-chip>
                  </template>

                  <span class="background--text body-1">
                    {{
                      $t("screener.purchased.tooltip") +
                        $t("screener.purchased.receipt.title")
                    }}
                  </span>
                </v-tooltip>
              </template>

              <v-tooltip slot="append" top color="primary">
                <v-chip
                  slot="activator"
                  outline
                  v-if="isConsumerEnrolled(props.item.id)"
                  color="secondary"
                  class="cursor-pointer white--text"
                  small
                  @click.stop
                >
                  <strong>{{ $t("screener.reserved.title") }}</strong>
                </v-chip>
                <span class="background--text body-1">
                  {{ $t("screener.reserved.tooltip") }}
                </span>
              </v-tooltip>
            </div>
          </td>
          <td
            class="pa-3"
            :width="$vuetify.breakpoint.width < 1264 ? '20%' : '15%'"
          >
            <MiniCountDown
              v-if="checkScreeningDateIsFuture(props.item.screening_starts_at)"
              :screener_date="props.item.screening_starts_at"
            />
          </td>
          <td class="pa-3 text-xs-right">
            <div>
              <v-btn
                v-if="isConsumerEnrolled(props.item.id)"
                small
                :disabled="props.item.is_geo_blocked"
                color="primary background--text"
                @click.stop="goToWatchPage(props.item)"
                >{{ $t("screener.btn.watch") }}</v-btn
              >
              <v-btn
                v-else
                small
                :disabled="props.item.is_geo_blocked"
                color="primary background--text"
                @click.stop="enrollToScreening(props.item)"
                >{{ $t("screener.btn.participate") }}</v-btn
              >
              <!-- Alert for geo-blocking -->
              <v-tooltip top v-if="props.item.is_geo_blocked" color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="error" class="px-1"
                    >mdi-alert</v-icon
                  >
                </template>
                <span class="secondary--text body-1">{{
                  $t("screener.geo_blocked")
                }}</span>
              </v-tooltip>
            </div>

            <div class="mt-2" v-if="props.item.pivot.purchase_id != null">
               <span class="cursor-pointer" @click.stop="onBeforeSubmitRequest(props.item)">
                {{ $t("booking.refund.request.button") }}
              </span>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-layout row wrap justify-center text-xs-center class="pa-5">
          <v-flex xs12 class="py-2 title secondary--text">
            {{ $t("screener.consumer.no_screenings") }}
          </v-flex>
          <v-flex xs12 class="py-2">
            <router-link
              class="primary--text subheading"
              :to="{ name: 'screeners.upcoming' }"
              >{{ $t("screener.browse_screenings.title") }}</router-link
            >
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
    <RefundModification
        :dialog="refundModificationDialog"
        :eventTitle="screener?screener.title:null"
        :screener_id="screener?screener.id:null"
        :purchase_id="screener?screener.pivot.purchase_id:null"
        @reset="resetRequestFormParam"
    ></RefundModification>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MiniCountDown from "@/components/MiniCountDown";
import { isDateFuture } from "@/helpers";
import i18n from "@/i18n";
import DEFINES from '@/defines';
import RefundModification from "@/components/dialogBox/RefundModification";

export default {
  name: "ConsumerScreenings",
  props: {
    eventType: {
      type: String,
      default: DEFINES.EVENT_TYPE.STANDARD_EVENTS,
    }
  },
  data() {
    return {
      refundModificationDialog:false,
      screener:null
    };
  },
  computed: {
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("company", {
      currentCompanyId: "getCurrentCompanyId"
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      screenings: "getScreenings",
      vodEventEndTime: "getVodEventEndTime",
      isVodEventExpired: "isVodEventExpired",
      isVodEventActive: "isVodEventActive"
    }),
    currentLocale(){
      return this.$i18n.locale;
    },
  },
  components: {
    MiniCountDown,
    RefundModification
  },
  created() {
    this.getDataFromApi();
  },
  methods: {
    goToWatchPage(screener) {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener.id
        }
      });
    },
    goToScreenerOverview(screener) {
      this.$router.push({
        name: "screeners.overview",
        params: {
          screener_id: screener.id
        }
      });
    },
    checkScreeningDateIsFuture(scrn_start_date) {
      return isDateFuture(scrn_start_date);
    },
    async getDataFromApi() {
      try {
        await this.$store.dispatch("consumer/listScreenings", {
          company_id: this.currentCompanyId
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    viewReceipt(receipt_url) {
      if (receipt_url) {
        window.open(receipt_url);
      }
    },
    async enrollToScreening(screener) {
      try {
        let response = await this.$store.dispatch(
          "consumer/enrollToScreening",
          {
            screener_id: screener.id
          }
        );
        await this.$store.dispatch("app/showMessage", {
          message: i18n.t("screener.enrolled_success"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    onBeforeSubmitRequest(item) {
        this.screener = item;
        this.refundModificationDialog = true;
    },

    resetRequestFormParam() {
      this.screener = null;
      this.refundModificationDialog = false;
    }
  }
};
</script>
